module.exports = __webpack_public_path__ + "img/应用场景_项目汇报.23ca9019.png";